import React, { Component, Fragment } from "react"
import { Button, DialogTitle, DialogContent, TextField, DialogActions, Grid, Dialog, TextareaAutosize, Tooltip } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import GetAppIcon from '@material-ui/icons/GetApp';
import Autocomplete from "@material-ui/lab/Autocomplete"
import AttachmentIcon from '@material-ui/icons/Attachment';
import InfoIcon from '@material-ui/icons/Info';
import LinkIcon from '@material-ui/icons/Link';
import { fieldValidation } from "../../../../utils/formValidation"
import { formValues, taskErrorCode } from "../containers/UtilizationTaskFormData"
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from "@material-ui/pickers"
import moment from "moment"
import axios from 'axios';
import { getLocalStorageInfo, format_Commas } from "../../../../utils";
import MomentUtils from "@date-io/moment"
import { backendDateFormat, dayMonthDateFormat,fieldDMYShort } from "../../../../constants"
import { addUtilFormApi, deleteAdAttachment, utilizatioPeriodDateApi, getOperatorList,utilApprovalFlowApi, getRemovalDateData} from "../apiServices"
import { regexConstants } from "../../../../constants/regEx"
import { checkApiStatus } from "../../../../utils"
import { globalPutService } from "../../../../utils/globalApiServices"
import LinkFiles from "../../../../shared_elements/components/LinkFiles"
import UploadFile from "../../../../shared_elements/components/UploadFile"
import { getAllOppThrust, allDropDownList } from "../../../home/apiServices";
import { PageLoader } from "../../../../shared_elements";
import { assetType, imgStoragePath, specificKey } from "../../../../constants";
import config from "../../../../config";
import { globalPostService } from "../../../../utils/globalApiServices";
import { trackActivity } from "../../../../utils/mixpanel";
import { validationMess } from "../../../../utils";
import { smbcInstance,acumenCamo } from "../../../../shared_elements/components";
class UtilizationFormData extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: {},
            data: {
                ...formValues,
                location_reg_aircraft: this.props.assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.location_reg_aircraft)[0] ? this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.location_reg_aircraft)[0] : formValues?.location_reg_aircraft,
                location_country: this.props.assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.location_country)[0] ? this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.location_country)[0] : this.props.basicDetails?.country ? this.props.basicDetails?.country : formValues?.location_country,
                location_position: this.props.assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.location_position)[0] ? this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.location_position)[0] : this.props.basicDetails?.location_position ? this.props.basicDetails?.country : formValues?.location_position,
                operating_environment: this.props.assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.operating_environment)[0] ? this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.operating_environment)[0] : this.props.basicDetails?.operating_environment ? this.props.basicDetails?.operating_environment : formValues?.operating_environment,
                engine_stand_location: this.props.assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.engine_stand_location)[0] ? this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.engine_stand_location)[0] : formValues?.engine_stand_location,
                removal_tslsv:this.props.basicDetails?.tslv ? this.props.basicDetails?.tslv : formValues?.removal_tslsv,
                removal_cslsv:this.props.basicDetails?.cslv ? this.props.basicDetails?.cslv : formValues?.removal_cslsv,
                // For the first utilization entry, TSN/CSN are derived from Basic Detail (base) + entered monthly FH/FC.
                // Pre-fill the base here so the field shows the Basic Detail value (including 0) before any monthly value is entered.
                tsn: (!this.props.assetsDetail?.filter(item => item?.util_approval_status?.id !== 2)?.length && this.props.basicDetails?.tsn !== undefined && this.props.basicDetails?.tsn !== null) ? this.props.basicDetails?.tsn : formValues?.tsn,
                csn: (!this.props.assetsDetail?.filter(item => item?.util_approval_status?.id !== 2)?.length && this.props.basicDetails?.csn !== undefined && this.props.basicDetails?.csn !== null) ? this.props.basicDetails?.csn : formValues?.csn
            },
            attachments: [],
            newUploadedAttachments: [],
            btnStatus: "",
            open: false,
            deleteAttachmentId: 0,
            showSuccessUpload: false,
            linkFile: false,
            uploadFile: false,
            operatingThrust: [],
            // previousEnv: this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.operating_environment)[0],
            // locationRegA_c: this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.location_reg_aircraft)[0],
            positionDropDownList: [],
            pageLoader: false,
            utilDateList: [],
            addanotherFormData: {},
            operatorList: [],
            utilApprovalflow:false,
            removalSvData: {}
        }
        this.addUtilFormApi = addUtilFormApi.bind(this)
        this.getOperatorList = getOperatorList.bind(this)
        this.getAllOppThrust = getAllOppThrust.bind(this)
        this.allDropDownList = allDropDownList.bind(this)
        this.utilizatioPeriodDateApi = utilizatioPeriodDateApi.bind(this)
        this.utilApprovalFlowApi = utilApprovalFlowApi.bind(this)
        this.getRemovalDateData = getRemovalDateData.bind(this)

    }

    componentDidMount = () => {
        this.utilApprovalFlowApi()
        this.getOperatorList()
        if (this.props.editFormId) {
            this.fillEditData()
        }
        this.getAllOppThrust(this.props.props.match.params, this.props.engineType?.engine_type)
        this.allDropDownList()
        this.utilizatioPeriodDateApi(this.props.props.match.params)
        this.getRemovalDateData(this.props.props.match.params)
        trackActivity('Utilization ADD Modal Opened - CAMO', {
            event_type: 'Modal Opened',
            page_title: 'Utilization Add Task Form',
        })
    }
    handleOpenFile = () => {
        this.setState({ linkFile: true })
    };

    handleCloseFile = () => {
        this.setState({ linkFile: false })
    };
    handleOpenUploadFile = () => {
        this.setState({ uploadFile: true })
    };
    handleUploadFileCloseFile = () => {
        this.setState({ uploadFile: false })
    };

    onFieldChange = (keyParam, value) => {
        if (keyParam === "location_country") {
            this.setState({ previousLocation: value });
        }
        // if (keyParam === "operating_environment") {
        //     this.setState({ previousEnv: value });
        // }

        // First utilization entry: TSN = base + Monthly FH, CSN = base + Monthly FC.
        // Base = getFirstEntryBaseTsn/Csn (Basic Detail on add; saved TSN/CSN − saved monthly on edit,
        // since Basic Detail is advanced to the current value once the entry is saved).
        // (Removal TSLSV/CSLSV are derived separately in getRemovalTslsv/getRemovalCslsv, not here.)
        if (keyParam === "monthly_FH" || keyParam === "monthly_FC") {
            const approvedCount = this.props.assetsDetail?.filter(item => item?.util_approval_status?.id !== 2)?.length || 0;
            const isFirstUtilEntry = this.props.actionType === "edit" ? approvedCount === 1 : approvedCount === 0;
            // if (isFirstUtilEntry) {
                if (keyParam === "monthly_FH") {
                    const computedTsn = this.getFirstEntryBaseTsn() + (parseFloat(value) || 0);
                    this.setState((prevState) => ({
                        ...prevState,
                        data: { ...prevState.data, ['monthly_FH']: value, ['tsn']: computedTsn },
                    }));
                } else {
                    const computedCsn = this.getFirstEntryBaseCsn() + (parseInt(value) || 0);
                    this.setState((prevState) => ({
                        ...prevState,
                        data: { ...prevState.data, ['monthly_FC']: value, ['csn']: computedCsn },
                    }));
                }
                return;
            // }
        }
        if (keyParam === "date_of_installation" && !value) {
            this.setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    ['fitment_aircraft_flying_cycle']: null,
                    ['fitment_aircraft_flying_hours']: null,
                    ['fitment_operator']: null,
                    ['fitment_aircraft']: null,
                },
            }))
        }
        if (keyParam === "date_of_removal" && !value) {
            this.setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    ['removal_aircraft_flying_hours']: null,
                    ['removal_aircraft_flying_cycle']: null,
                    ['removal_tslsv']: null,
                    ['removal_cslsv']: null,
                    ['removal_egtm']: null,
                    ['removal_event']: null,
                },
            }))
        }
        if (keyParam === "date_of_removal" && value) {
            // Re-selecting a Date of Removal after it was cleared: the removal fields were wiped to null when
            // the date was removed. Restore the saved Removal TSLSV/CSLSV so the (edit, untouched-inputs)
            // display — which reads data.removal_tslsv/cslsv — shows the existing value again instead of blank.
            this.setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    ['removal_tslsv']: prevState.data?.removal_tslsv ?? prevState.savedUtilData?.removal_tslsv ?? null,
                    ['removal_cslsv']: prevState.data?.removal_cslsv ?? prevState.savedUtilData?.removal_cslsv ?? null,
                },
            }))
        }
        if (keyParam === "utilization_period" && !value) {
            this.setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    ['utilization_period']: null,
                    ['utilization_period_from']: null,
                    ['utilization_period_to']: null,
                    ['date_of_installation']: null,
                    ['date_of_removal']: null,
                },
            }))
        } else {
            if (keyParam === "utilization_period") {
                const approvalData = this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2);
                let latestUtilMonth = moment(this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.utilization_period)[0]?.value)
                if (moment(value?.value).diff(latestUtilMonth, 'days') > 31) {
                    this.props.props.enqueueSnackbar("Please,enter the previous month's utilization.", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                }
                this.setState((prevState) => ({
                    ...prevState,
                    data: {
                        ...prevState.data,
                        [keyParam]: value,
                        ['utilization_period_from']: !approvalData?.length ? moment(value?.value).isSame(this.props.basicDetails?.date_of_manufacture, 'month')  ? moment(this.props.basicDetails?.date_of_manufacture).format(backendDateFormat) : moment(value?.data).format(backendDateFormat) :
                         (approvalData.sort((a, b) => b - a).map(filter => filter?.utilization_period)[0]?.data === value?.data) ?
                            approvalData?.sort((a, b) => b - a).map(datefilter => datefilter?.utilization_period_to)[0] : moment(value?.data).format(backendDateFormat),
                        ['utilization_period_to']: value?.value,
                        ['date_of_installation']: null,
                        ['date_of_removal']: null,
                    },
                }))
            } else {
                this.setState((prevState) => ({
                    ...prevState,
                    data: {
                        ...prevState.data,
                        [keyParam]: value,
                    },
                }))
            }
        }

    }

    onRestErrorKey = (keyParam) => {
        this.setState((prevState) => ({
            ...prevState,
            error: {
                ...prevState.error,
                [keyParam]: "",
            },
        }))
    }
    handleSubmit = (e) => {
        this.setState({ pageLoader: true });
        e.preventDefault()
        let validationInputs = {}
        const { data,utilApprovalflow} = this.state
        const prevsThrustValue = this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.current_operating_thrust)[0]
        this.setState({ file: "" })
        validationInputs = {
            ...validationInputs,
            utilization_period: taskErrorCode["utilization_period"][fieldValidation({ ...taskErrorCode["utilization_period_obj"], fieldval: data.utilization_period, })],
            monthly_FH: regexConstants.alphanumespcespclchar.test(data?.monthly_FH) ? 'Monthly FH value should be allowed between 0 to 999.99' : data?.monthly_FH ? '' : "Please Enter Monthly FH",
            monthly_FC: regexConstants.alphanumespcespclchar.test(data?.monthly_FC) ? 'Monthly FC value should be allowed between 0 to 999' : data?.monthly_FC ? '' : "Please Enter Monthly FC",
            current_operating_thrust:acumenCamo ? '': data?.current_operating_thrust || prevsThrustValue ? '' : "Please Select Current Operating Thrust",
            utilization_period_from: data?.utilization_period_from ? '' : "Please Enter Utilization From Date",
            utilization_period_to: data?.utilization_period_to ? '' : "Please Enter Utilization To Date "
        }
        if (
            Object.keys(validationInputs).every((k) => {
                return validationInputs[k] === ""
            })
        ) {
            this.setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                },
            }))

            const props = this.props.props
            const utilData = data
            utilData.removal_tslsv = utilData?.removal_tslsv ? utilData?.removal_tslsv : null
            utilData.removal_cslsv = utilData?.removal_cslsv ? utilData?.removal_cslsv : null
            utilData.removal_aircraft_flying_hours = utilData?.removal_aircraft_flying_hours ? utilData?.removal_aircraft_flying_hours : null
            utilData.removal_aircraft_flying_cycle = utilData?.removal_aircraft_flying_cycle ? utilData?.removal_aircraft_flying_cycle : null
            utilData.fitment_aircraft_flying_hours = utilData?.fitment_aircraft_flying_hours ? utilData?.fitment_aircraft_flying_hours : null
            utilData.fitment_aircraft_flying_cycle = utilData?.fitment_aircraft_flying_cycle ? utilData?.fitment_aircraft_flying_cycle : null
            const approvalData = this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2);
            utilData.redirect_url = window?.location?.href // 1 Approved 2 Rejected 3 Pending 4 historical data
            utilData.util_approval_status = utilApprovalflow ? getLocalStorageInfo()?.user?.security_groups?.find(item => item?.id === 29) ? 1 : 3 : 4
            utilData.utilization_period = utilData.utilization_period ? utilData.utilization_period : ''
            utilData.location_country = utilData.location_country ? utilData.location_country : this.props.basicDetails?.country
            utilData.operating_environment = utilData?.operating_environment ? utilData?.operating_environment : this.props.basicDetails?.operating_environment
            const prevsThrustValue = this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.current_operating_thrust)[0]
            const filterPosition = this.state.positionDropDownList.filter(item => item.id === this.props.basicDetails.position)[0]
            const prevsPositionValue = ({ label: filterPosition?.label, value: filterPosition?.id })
            utilData.location_position = utilData.location_position ? utilData.location_position : filterPosition || null
            utilData.asset_id = props.match.params.asset
            utilData.engine_stand_location = utilData.engine_stand_location ? utilData.engine_stand_location : ''
            utilData.asset_type_id = props.match.params.assetType
            utilData.monthly_FC = utilData.monthly_FC ? +utilData.monthly_FC : 0
            utilData.monthly_FH = utilData.monthly_FH ? +utilData.monthly_FH : 0
            utilData.monthly_derate = utilData.monthly_derate !== null && utilData.monthly_derate !== undefined && utilData.monthly_derate !== '' ? +utilData.monthly_derate : null
            utilData.tsn = approvalData?.length > 1 ? parseFloat(approvalData.sort((a, b) => b - a).filter(filterId => filterId?.id)[0]?.tsn) + parseFloat(utilData?.monthly_FH) : +utilData.tsn
            utilData.csn = approvalData?.length > 1 ? parseInt(approvalData.sort((a, b) => b - a).filter(filterId => filterId?.id)[0]?.csn) + parseInt(utilData?.monthly_FC) : +utilData.csn
            // Removal TSLSV/CSLSV are derived from the finalized TSN/CSN and the SV reset data (get_removal_date_data).
            const removalTslsv = this.getRemovalTslsvFrom(utilData?.tsn)
            utilData.removal_tslsv = Number.isFinite(removalTslsv) ? removalTslsv.toFixed(2) : null
            utilData.removal_cslsv = this.getRemovalCslsvFrom(utilData?.csn)
            // Removal TSLSV/CSLSV are only shown in the UI when a Date of Removal exists; keep the payload consistent.
            if (!utilData?.date_of_removal) {
                utilData.removal_tslsv = null
                utilData.removal_cslsv = null
            }
            utilData.current_operating_thrust = utilData.current_operating_thrust ? utilData.current_operating_thrust : prevsThrustValue ? prevsThrustValue : null
            let latestUtilMonth = moment(approvalData?.sort((a, b) => b - a).map(filterId => filterId?.utilization_period)[0]?.value)
            const isFromDate = approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period_from
            const isToDate = approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period_to
            const enteredFromDate = data?.utilization_period_from;
            const enteredToDate = data?.utilization_period_to;
            const isSameFromDate = isFromDate === enteredFromDate;
            const isSameToDate = isToDate === enteredToDate;
            const isSameDates = isSameFromDate && isSameToDate;
            const isUtilPeriod = approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period?.data === data?.utilization_period?.data

            if (approvalData?.length > 0 && isUtilPeriod && isSameDates) {
                this.props.props.enqueueSnackbar("This entry is already exist.", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                this.setState({ pageLoader: false });
            } else if (moment(utilData?.utilization_period?.value).diff(latestUtilMonth, 'days') > 31) {
                this.props.props.enqueueSnackbar("Please,enter the previous month's utilization.", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                this.setState({ pageLoader: false });
            }
             else {
                globalPostService(`camo/util/`, utilData).then((response) => {
                    this.setState({ addanotherFormData: response?.data?.data })
                    if (response?.status === 500 || response.data?.statusCode === 500) {
                        this.setState({ pageLoader: false });
                        this.props.props.enqueueSnackbar(response.data?.statusCode === 500 ? response.data?.message : "Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                    } else {
                        // this.props.props.enqueueSnackbar(response.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
                    }
                    const uploadId = response?.data?.data?.id
                    if (uploadId) {
                        this.uploadFileTest(uploadId, props, false)
                        trackActivity('Utilization Data Added Successfully - CAMO', {
                            event_type: 'Data Added Successfully',
                            page_title: 'Utilization',
                            item_id: uploadId ? uploadId : '',
                            response_msg: response?.data?.message || ''
                        })
                    }
                    if (this.state.btnStatus !== "addAnother" && uploadId) {
                        this.props.closeAddForm()
                    } else {
                        return false
                    }
                    this.setState({ pageLoader: false });
                });
            }
        } else {
            this.setState({ pageLoader: false });
            this.setState({ error: validationInputs })
            trackActivity('Utilization Data Added Failed - CAMO', {
                event_type: 'Add Data Failed',
                page_title: 'Utilization',
                error_source: 'Frontend',
                error_type: validationInputs ? validationInputs : ''
            })
        }
    }
    fillEditData = () => {
        const updateId = this.props.editFormId
        this.setState({ attachments: this.props.attachments })
        if (updateId === undefined || updateId === null) {
            this.setState({
                data: {},
            })
        } else {
            this.setState({
                data: this.props.editFormData,
                // Snapshot the saved driving inputs and saved Removal TSLSV/CSLSV so we only re-derive
                // Removal values (via getRemovalTslsvFrom/getRemovalCslsvFrom + SV reset data) when the
                // user actually changes FH/FC/TSN/CSN. If untouched, the originally saved value is kept,
                // even if the SV reset config changed after the record was saved.
                savedUtilData: {
                    monthly_FH: this.props.editFormData?.monthly_FH,
                    monthly_FC: this.props.editFormData?.monthly_FC,
                    tsn: this.props.editFormData?.tsn,
                    csn: this.props.editFormData?.csn,
                    removal_tslsv: this.props.editFormData?.removal_tslsv,
                    removal_cslsv: this.props.editFormData?.removal_cslsv,
                },
            })
        }
    }
    // In edit mode, Removal TSLSV/CSLSV are only re-derived from the SV reset data when the user
    // actually changes one of the driving inputs (FH/FC/TSN/CSN). Otherwise the saved value is shown/kept.
    isUtilInputChanged = () => {
        const { data, savedUtilData } = this.state;
        if (!savedUtilData) return false;
        const num = (v) => (v === '' || v === null || v === undefined) ? null : Number(v);
        return num(data?.monthly_FH) !== num(savedUtilData?.monthly_FH)
            || num(data?.monthly_FC) !== num(savedUtilData?.monthly_FC)
            || num(data?.tsn) !== num(savedUtilData?.tsn)
            || num(data?.csn) !== num(savedUtilData?.csn);
    }
    // Whether Removal TSLSV/CSLSV should be freshly derived from the current TSN/CSN + SV reset data
    // (instead of reusing the originally saved value). True on add, when the driving inputs
    // (FH/FC/TSN/CSN) changed, or when a Date of Removal now exists but no Removal value was ever saved —
    // e.g. the entry was originally added WITHOUT a Date of Removal (removal_tslsv/cslsv null) and the user
    // is now selecting a Date of Removal in edit, so we must derive & show/send the Removal values.
    shouldDeriveRemoval = () => {
        const { data, savedUtilData } = this.state;
        const isEmpty = (v) => v === null || v === undefined || v === '';
        const noSavedRemoval = isEmpty(savedUtilData?.removal_tslsv) && isEmpty(savedUtilData?.removal_cslsv);
        return this.props.actionType === "add"
            || this.isUtilInputChanged()
            || (!!data?.date_of_removal && noSavedRemoval);
    }
    updateData = async (e) => {
        e.preventDefault()
        let validationInputs = {}
        const { data} = this.state
        this.setState({ file: "" })
        validationInputs = {
            ...validationInputs,
            utilization_period: taskErrorCode["utilization_period"][fieldValidation({ ...taskErrorCode["utilization_period_obj"], fieldval: data.utilization_period, })],
            monthly_FH: regexConstants.alphanumespcespclchar.test(data?.monthly_FH) ? 'Monthly FH value should be allowed between 0 to 999.99' : data?.monthly_FH ? '' : "Please Enter Monthly FH",
            monthly_FC: regexConstants.alphanumespcespclchar.test(data?.monthly_FC) ? 'Monthly FC value should be allowed between 0 to 999' : (data?.monthly_FC || data?.monthly_FC === 0) ? '' : "Please Enter Monthly FC",
            current_operating_thrust: acumenCamo ? '': data?.current_operating_thrust ? '' : "Please Select Current Operating Thrust",
            utilization_period_from: data?.utilization_period_from ? '' : "Please Enter Utilization From Date",
            utilization_period_to: data?.utilization_period_to ? '' : "Please Enter Utilization To Date ",
            remarks: data?.remarks?.trim() ? "" : "Please enter remarks"
        }
        if (
            Object.keys(validationInputs).every((k) => {
                return validationInputs[k] === ""
            })
        ) {
            this.setState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                },
            }))
            const updateId = this.props.editFormId
            const updatedData = this.state.data
            delete updatedData.util_approval_status
            const props = this.props.props
            updatedData.removal_tslsv =  updatedData?.removal_tslsv ?  updatedData?.removal_tslsv : null
            updatedData.removal_cslsv =  updatedData?.removal_cslsv ?  updatedData?.removal_cslsv : null
            updatedData.removal_aircraft_flying_hours =  updatedData?.removal_aircraft_flying_hours ?  updatedData?.removal_aircraft_flying_hours : null
            updatedData.removal_aircraft_flying_cycle =  updatedData?.removal_aircraft_flying_cycle ?  updatedData?.removal_aircraft_flying_cycle : null
            updatedData.fitment_aircraft_flying_hours =  updatedData?.fitment_aircraft_flying_hours ?  updatedData?.fitment_aircraft_flying_hours : null
            updatedData.fitment_aircraft_flying_cycle =  updatedData?.fitment_aircraft_flying_cycle ?  updatedData?.fitment_aircraft_flying_cycle : null
            const approvalData = this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2);
            updatedData.redirect_url = window?.location?.href
            const prevsThrustValue = this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.current_operating_thrust)[0]
            updatedData.location_country = updatedData.location_country ? updatedData.location_country : this.props.basicDetails?.country
            updatedData.operating_environment = updatedData?.operating_environment ? updatedData?.operating_environment : this.props.basicDetails?.operating_environment
            updatedData.engine_stand_location = updatedData.engine_stand_location ? updatedData.engine_stand_location : ''
            updatedData.monthly_FC = updatedData.monthly_FC ? +updatedData.monthly_FC : 0
            updatedData.monthly_FH = updatedData.monthly_FH ? +updatedData.monthly_FH : 0
            updatedData.monthly_derate = updatedData.monthly_derate !== null && updatedData.monthly_derate !== undefined && updatedData.monthly_derate !== '' ? +updatedData.monthly_derate : null
            const indexing = approvalData?.map((item, index) => item?.id).sort((b, a) => b - a)[0] === this.props.item?.id
            // Persist exactly what the form shows: newest entry uses the (editable) data.tsn/csn; every other
            // edit (first-created or middle) uses tsnCalc/csnCalc — the same source the TSN/CSN fields render from.
            updatedData.tsn = indexing ? +data.tsn : approvalData?.length > 1 ? (parseFloat(this.tsnCalc()) || 0) : +data.tsn || 0
            updatedData.csn = indexing ? +data.csn : approvalData?.length > 1 ? (parseInt(this.csnCalc()) || 0) : +data.csn || 0
            // Re-derive Removal TSLSV/CSLSV from the finalized TSN/CSN + SV reset data when the user changed
            // FH/FC/TSN/CSN, OR when a Date of Removal now exists but no Removal value was ever saved (entry was
            // originally added without a Date of Removal). Otherwise keep the originally saved value.
            if (this.shouldDeriveRemoval()) {
                const updatedRemovalTslsv = this.getRemovalTslsvFrom(isNaN(updatedData?.tsn) ? 0 : updatedData?.tsn)
                updatedData.removal_tslsv = Number.isFinite(updatedRemovalTslsv) ? updatedRemovalTslsv.toFixed(2) : null
                updatedData.removal_cslsv = this.getRemovalCslsvFrom(isNaN(updatedData?.csn) ? 0 : updatedData?.csn)
            } else {
                updatedData.removal_tslsv = this.state.savedUtilData?.removal_tslsv ?? null
                updatedData.removal_cslsv = this.state.savedUtilData?.removal_cslsv ?? null
            }
            // Removal TSLSV/CSLSV are only shown in the UI when a Date of Removal exists; keep the payload consistent.
            if (!updatedData?.date_of_removal) {
                updatedData.removal_tslsv = null
                updatedData.removal_cslsv = null
            }
            updatedData.current_operating_thrust = updatedData.current_operating_thrust ? updatedData?.current_operating_thrust : null
            const filterPosition = this.state.positionDropDownList.filter(item => item.id === this.props.item?.location_position?.value)[0]
            const prevsPositionValue = ({ label: filterPosition?.label, value: filterPosition?.id })
            updatedData.location_position = updatedData.location_position ? updatedData.location_position : filterPosition || null
            const isFromDate = approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period_from
            const isToDate = approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period_to
            const enteredFromDate = data?.utilization_period_from;
            const enteredToDate = data?.utilization_period_to;

            const isSameFromDate = isFromDate === enteredFromDate;
            const isSameToDate = isToDate === enteredToDate;
            const isIdCompare = updateId === approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.id
            const isSameDates = isIdCompare ? null : isSameFromDate && isSameToDate;
            const isUtilPeriod = approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period?.data === data?.utilization_period?.data
            const finalUpdatedData = {...updatedData,tsn:isNaN(updatedData?.tsn) ? 0 : updatedData?.tsn, csn:isNaN(updatedData?.csn) ? 0 :updatedData?.csn,}
            if (approvalData?.length > 0 && isUtilPeriod && isSameDates) {
                this.props.props.enqueueSnackbar("This entry is already exist.", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                this.setState({ pageLoader: false });
            }
            else {
                if (updateId) {
                    await this.uploadFileTest(updateId, props, true)
                }
                await this.props.updateFormData(updateId, finalUpdatedData, props, this.props)
                trackActivity('Utilization Updated Successfully - CAMO', {
                    event_type: 'Data Updated Successfully',
                    page_title: 'Utilization',
                    item_id: updateId ? updateId : '',
                })
            }
        } else {
            this.setState({ error: validationInputs })
            trackActivity('Utilization Data Updated Failed - CAMO', {
                event_type: 'Update Data Failed',
                page_title: 'Utilization',
                error_source: 'Frontend',
                error_type: validationInputs ? validationInputs : ''
            })
        }
    }

    uploadFileTest = async (uploadId, props, isUpdate) => {
        if (this.state.newUploadedAttachments.length > 0) {
            let newAttachmentObj = []
            let formdata = new FormData()
            const module_type_id = 11
            Object.keys(this.state.newUploadedAttachments).map((key, index) => {
                newAttachmentObj.push({
                    file: this.state.newUploadedAttachments[key],
                    file_name: this.state.newUploadedAttachments[key].name,
                    file_type: this.state.newUploadedAttachments[key].type,
                    module_type_id,
                    module_id: uploadId,
                    asset_id: this.props.props.match.params.asset,
                    asset_type_id: this.props.props.match.params.assetType

                })
                formdata.append(
                    "[" + key + "]file",
                    this.state.newUploadedAttachments[key]
                )
                formdata.append(
                    "[" + key + "]file_type",
                    this.state.newUploadedAttachments[key].type
                )
                formdata.append(
                    "[" + key + "]file_name",
                    this.state.newUploadedAttachments[key].name
                )
                formdata.append("[" + key + "]module_id", uploadId)
                formdata.append("[" + key + "]module_type_id", module_type_id)
                formdata.append("[" + key + "]asset_id", this.props.props.match.params.asset)
                formdata.append("[" + key + "]asset_type_id", this.props.props.match.params.assetType)
            })
            this.props.fileUploadData(uploadId, formdata, props, true)
            if (this.state.btnStatus === "addAnother") {
                this.resetBothAttachmentArray()
            }
            if (!isUpdate) {
                this.onSubmitFileLink(uploadId)
                this.props.fileUploadData(uploadId, null, props, false)
            }
        } else {
            if (this.state.btnStatus === "addAnother") {
                const { addanotherFormData } = this.state
                this.props.fileUploadData(uploadId, null, props, false)
                document.getElementById("asset-form")?.reset()
                this.setState({ pageLoader: false });
                this.setState((prevState) => ({
                    ...prevState,
                    data: {
                        ...formValues,
                        location_reg_aircraft: addanotherFormData?.location_reg_aircraft,
                        location_country: addanotherFormData?.location_country,
                        location_position: addanotherFormData?.location_position,
                        operating_environment: addanotherFormData?.operating_environment,
                        engine_stand_location: addanotherFormData?.engine_stand_location,
                    },
                    attachments: [],
                }))
            } else {
                if (!isUpdate) {
                    this.onSubmitFileLink(uploadId)
                    this.props.fileUploadData(uploadId, null, props, false)
                }
            }
        }
    }

    resetBothAttachmentArray = () => {
        const { addanotherFormData } = this.state
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...formValues,
                location_reg_aircraft: addanotherFormData?.location_reg_aircraft,
                location_country: addanotherFormData?.location_country,
                location_position: addanotherFormData?.location_position,
                operating_environment: addanotherFormData?.operating_environment,
                engine_stand_location: addanotherFormData?.engine_stand_location,
            },
            attachments: [],
            newUploadedAttachments: [],
            open: false,
            deleteAttachmentId: 0,
        }))
        document.getElementById("asset-form")?.reset()
        this.setState({ pageLoader: false });
    }

    onUpload = (files) => {
        const chosenFiles = Array.prototype.slice.call(files)
        for (let i = 0; i < chosenFiles.length; i++) {
            if (chosenFiles[i].size > 52428800) {
                this.props.props.enqueueSnackbar(
                    `${chosenFiles[i].name} Maximum file size should be 50MB.`,
                    {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                    }
                )
                delete chosenFiles[i]
                continue
            } else {
                this.handleUploadFiles(chosenFiles)
                // document.querySelector(".MuiDialog-paper").scrollTop = 800;
                this.setState({
                    showSuccessUpload: true,
                })
                setTimeout(() => {
                    if (this.state.attachments) {
                        this.setState({
                            showSuccessUpload: false,
                        })
                    }
                }, 2500)
            }
        }
    }

    handleUploadFiles = (files) => {
        const uploaded = [...this.state.newUploadedAttachments]
        const existingAttachments = [...this.state.attachments]
        files.some((file) => {
            uploaded.push(file)
        })
        files.map((file) => {
            var objc = {
                id: 0,
                module_id: 0,
                module_type_id: 11,
                file_name: file.name,
                file_type: file.type,
                file: "",
                name: file.name,
                asset_id: this.props.props.match.params.asset,
                asset_type_id: this.props.props.match.params.assetType
            }
            existingAttachments.push(objc)
        })

        this.setState({
            newUploadedAttachments: uploaded,
            attachments: existingAttachments,
        })
    }

    handleClickAttachment = (e, id) => {
        this.setState({ open: true })
        this.setState({ deleteAttachmentId: id })
    }

    handleCloseAttachment = (e) => {
        this.setState({ open: false })
        this.setState({ deleteAttachmentId: 0 })
    }

    deleteAttachmentFile = async (id, file) => {
        if (id !== undefined && id !== 0) {
            const props = this.props.props
            deleteAdAttachment(id, props)
            var array = [...this.state.attachments]
            array = array.filter((item) => item.id !== id)
            this.setState({ attachments: array, open: false, deleteAttachmentId: 0 })
        } else {
            this.onRemoveCamoFile(file)
        }
    }

    removeAttachment = (e, obj) => {
        var array = [...this.state.attachments]
        var newuploadarray = [...this.state.newUploadedAttachments]

        var filteredArray = []

        newuploadarray.map((file) => {
            if (file.name === obj.file_name && file.type === obj.file_type) {
            } else {
                filteredArray.push(file)
            }
        })
        // Set the state with the new filtered array
        array = array.filter((item) => item !== obj)
        this.setState({
            newUploadedAttachments: filteredArray,
            attachments: array,
        })

    }

    saveAndAddAnother = async (e) => {
        await this.setState({ btnStatus: "addAnother" })
        await this.handleSubmit(e)
    }

    addFormData = async (e) => {
        await this.setState({ btnStatus: "add" })
        this.handleSubmit(e)
    }

    getResponseBack = (file) => {
        const { data, } = this.state
        this.setState({
            data: {
                ...data,
                checklist: file,
            },
        });
    }
    listResponseBack = (file) => {
        if (this.props.actionType === "add" || 'edit') {
            return null
        } else {
            this.props.getResponseBack(file)
        }
    }
    downloadFile = (file) => {
        axios.get(decodeURIComponent(file.path), { timeout: 600000, responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.name);
                document.body.appendChild(link);
                link.click();
            })
    }
    onUnlinkCheckListFile = (checklist, fileId) => {
        const { data } = this.state;
        let payload = {};
        payload.delete = true;
        payload.folder_ids = checklist?.folders?.filter(items => items.type === 'folder').map(file => file.id).filter((id) => id !== fileId).join(',');
        payload.file_ids = checklist?.files?.filter(items => items.type === 'file').map(file => file.id).filter((id) => id !== fileId).join(',');
        globalPutService(`camo/util/${this.props.editFormId}/document-checklists/`, payload)
            .then((response) => {
                if (checkApiStatus(response)) {
                    const updatedChecklist = { ...checklist };
                    updatedChecklist.files = updatedChecklist.files.filter((file) => file.id !== fileId);
                    updatedChecklist.folders = updatedChecklist?.folders.filter((file) => file.id !== fileId);
                    this.setState({
                        data: {
                            ...data,
                            checklist: updatedChecklist,
                        },
                    });
                }
            });
    }
    onRemoveFile = (file) => {
        const { data } = this.state;
        this.setState({
            data: {
                ...data,
                checklist: data.checklist.filter(item => item.name !== file.name)
            }
        });
    }
    onRemoveCamoFile = (file) => {
        const { attachments } = this.state;
        this.setState({
            attachments: attachments.filter(item => item.file_name !== file.file_name)
        });
    }

    onLinkFile = (file, uuid, type) => {
        if (type === "link" || uuid) {
            const { data } = this.state;
            const folderUUID = [...data.folder_uuid, uuid];
            const updatedChecklist = [...data.checklist, file];

            let uuidData = [];
            let output = [];

            for (const arr of folderUUID) {
                uuidData = uuidData.concat(arr);
            }

            for (const arr of updatedChecklist) {
                output = output.concat(arr);
            }
            this.setState({
                data: {
                    ...data,
                    checklist: output,
                    folder_uuid: uuidData.join("")
                },
            });
        } else {
            this.onUpload(file)
        }

    }

    onSubmitFileLink = (id) => {
        const { data } = this.state;
        if (data?.checklist?.length > 0 && data.checklist.map(item => item.id).filter(item => item)) {
            let payload = {};
            if (data?.checklist.some(item => item.type === 'folder') && data?.checklist.some(item => item.type === 'file')) {
                payload.folder_ids = data?.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
                payload.file_ids = data?.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
            } else if (data?.checklist.some(item => item.type === 'folder')) {
                payload.folder_ids = data?.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
            } else {
                payload.file_ids = data?.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
            }
            globalPutService(`camo/util/${id}/document-checklists/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        this.props.getResponseBack()
                        // this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    } else {
                        this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                });
        }
        if (data?.folder_uuid?.length > 0 && data.folder_uuid) {
            let formData = new FormData();
            formData.append('folder_uuid', data.folder_uuid);
            for (let i = 0; i < data.checklist.filter(item => item instanceof File).length; i++) {
                formData.append('files[]', data.checklist.filter(item => item instanceof File).length && data.checklist.filter(item => item instanceof File)[i]);
            }
            globalPutService(`camo/util/${id}/document-checklists/`, formData)
                .then(response => {
                    if (checkApiStatus(response)) {
                        this.props.getResponseBack()
                    } else {
                        this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                });
        }
    }

    // Pre-utilization base for the first-created entry (TSN = base + Monthly FH, CSN = base + Monthly FC).
    // Add: Basic Detail TSN/CSN is the base. Edit: derive the base from the saved entry
    // (saved TSN/CSN − saved monthly) because Basic Detail is advanced to the current TSN/CSN after save,
    // so using it directly on edit would double-count the monthly value.
    getFirstEntryBaseTsn = () => {
        const { savedUtilData } = this.state;
        if (this.props.actionType === "edit" && savedUtilData) {
            return (parseFloat(savedUtilData?.tsn) || 0) - (parseFloat(savedUtilData?.monthly_FH) || 0);
        }
        return parseFloat(this.props.basicDetails?.tsn) || 0;
    }
    getFirstEntryBaseCsn = () => {
        const { savedUtilData } = this.state;
        if (this.props.actionType === "edit" && savedUtilData) {
            return (parseInt(savedUtilData?.csn) || 0) - (parseInt(savedUtilData?.monthly_FC) || 0);
        }
        return parseInt(this.props.basicDetails?.csn) || 0;
    }

    // Current TSN/CSN shown in the add form: first entry = Basic Detail base + monthly (held in data.tsn/csn),
    // subsequent entry = latest approved entry + monthly (same base tsnCalc/csnCalc use).
    getCurrentTsn = () => {
        const { data } = this.state;
        const approvalData = this.props.assetsDetail?.filter(item => item?.util_approval_status?.id !== 2) || [];
        if (this.props.actionType === "add" && approvalData.length > 0) {
            return (parseFloat(approvalData.sort((a, b) => b - a).filter(item => item)[0]?.tsn) || 0) + (parseFloat(data?.monthly_FH) || 0);
        }
        return parseFloat(data?.tsn) || 0;
    }
    getCurrentCsn = () => {
        const { data } = this.state;
        const approvalData = this.props.assetsDetail?.filter(item => item?.util_approval_status?.id !== 2) || [];
        if (this.props.actionType === "add" && approvalData.length > 0) {
            return (parseInt(approvalData.sort((a, b) => b - a).filter(item => item)[0]?.csn) || 0) + (parseInt(data?.monthly_FC) || 0);
        }
        return parseInt(data?.csn) || 0;
    }

    // Removal TSLSV/CSLSV (add flow): when sv_reset_tslsv_cslsv is true, subtract SV TSN/CSN from the current TSN/CSN
    // (from get_removal_date_data); negative results are clamped to 0. When SV reset is off, follow the current value.
    getRemovalTslsvFrom = (currentTsn) => {
        const { removalSvData } = this.state;
        const tsn = parseFloat(currentTsn) || 0;
        if (removalSvData?.sv_reset_tslsv_cslsv) {
            const result = tsn - (parseFloat(removalSvData?.sv_tsn_at_removal) || 0);
            return result < 0 ? 0 : result;
        }
        return tsn;
    }
    getRemovalCslsvFrom = (currentCsn) => {
        const { removalSvData } = this.state;
        const csn = parseInt(currentCsn) || 0;
        if (removalSvData?.sv_reset_tslsv_cslsv) {
            const result = csn - (parseInt(removalSvData?.sv_csn_at_removal) || 0);
            return result < 0 ? 0 : result;
        }
        return csn;
    }
    getRemovalTslsv = () => this.getRemovalTslsvFrom(this.getCurrentTsn())
    getRemovalCslsv = () => this.getRemovalCslsvFrom(this.getCurrentCsn())
    // Format a numeric Removal value for display: comma-separated with 2 decimals.
    // Empty/blank stays empty; anything non-numeric falls back to the cleaned string so no case breaks.
    formatRemovalTwoDecimals = (value) => {
        const cleaned = String(value ?? '').replace(/[^0-9.]/g, '')
        if (cleaned === '') return ''
        const num = parseFloat(cleaned)
        return Number.isFinite(num) ? format_Commas(num.toFixed(2)) : format_Commas(cleaned)
    }

    tsnCalc() {
        const { data } = this.state;
        // const filterdata = this.props.assetsDetail.filter(filterId => filterId);
        const approvalData = this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2);
        const currentIndex = approvalData?.findIndex(item => item.id === this.props.item?.id);
        const indexLength = approvalData?.filter(filterId => filterId)?.length - 1
        // First-created (oldest) entry = smallest id; detected by id so it works regardless of array order.
        const oldestId = approvalData?.length ? [...approvalData].map(item => item?.id).sort((a, b) => a - b)[0] : null;
        const isFirstCreatedEntry = oldestId != null && this.props.item?.id === oldestId;
        if (this.props.actionType === "add") {
            data.tsn = parseFloat(approvalData?.sort((a, b) => b - a).filter(item => item)[0]?.tsn) + parseFloat(+data?.monthly_FH) || ""
        } else {
            if (isFirstCreatedEntry) {
                // Editing the first-created entry: TSN = pre-utilization base + Monthly FH.
                data.tsn = this.getFirstEntryBaseTsn() + parseFloat(+data?.monthly_FH) || '';
            } else if (currentIndex >= 0 && currentIndex !== indexLength) {
                const previousEntry = approvalData[currentIndex + 1];
                data.tsn = parseFloat(previousEntry?.tsn) + parseFloat(+data?.monthly_FH) || '';
            } else {
                data.tsn = parseFloat(approvalData.find(item => item.id === this.props.item?.id)?.tsn) || '';
            }
        }
        return typeof data?.tsn === 'string' || data.tsn === '' || data.tsn ? data?.tsn > 0 ? parseFloat(data?.tsn).toFixed(2) : '' : ''
    }

    csnCalc() {
        const { data} = this.state;
        // const filterdata = this.props.assetsDetail.filter(filterId => filterId);
        const approvalData = this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2);
        const currentIndex = approvalData?.findIndex(item => item.id === this.props.item?.id);
        const indexLength = approvalData?.filter(filterId => filterId)?.length - 1
        // First-created (oldest) entry = smallest id; detected by id so it works regardless of array order.
        const oldestId = approvalData?.length ? [...approvalData].map(item => item?.id).sort((a, b) => a - b)[0] : null;
        const isFirstCreatedEntry = oldestId != null && this.props.item?.id === oldestId;
        if (this.props.actionType === "add") {
            data.csn = parseInt(approvalData?.sort((a, b) => b - a).filter(item => item)[0]?.csn) + parseInt(+data?.monthly_FC) || ""
        } else {
            if (isFirstCreatedEntry) {
                // Editing the first-created entry: CSN = pre-utilization base + Monthly FC.
                data.csn = this.getFirstEntryBaseCsn() + parseInt(data?.monthly_FC) || '';
            } else if (currentIndex >= 0 && currentIndex !== indexLength) {
                const previousEntry = approvalData[currentIndex + 1];
                data.csn = previousEntry?.csn + parseInt(data?.monthly_FC) || '';
            } else {
                data.csn = approvalData?.find(item => item.id === this.props.item?.id)?.csn || '';
            }
        }
        return data?.csn;
    }
    dor_Freeze = () => {
        const { data } = this.state
        const idbasedEqual = this.props.assetsDetail[0]?.id === this.props.item?.id
        if ((this.props.editFormId && this.props.assetsDetail[0]?.date_of_removal) && idbasedEqual) {
            return false
        } else if (data?.date_of_installation && idbasedEqual) {
            return false
        } else if (idbasedEqual) {
            return false
        } else if (!this.props.editFormId) {
            return false
        } else {
            return true
        }
    }
    doI_Freeze = () => {
        const idbasedEqual = this.props.assetsDetail[0]?.id === this.props.item?.id
        if ((this.props.editFormId && this.props.assetsDetail[0]?.date_of_installation) && idbasedEqual) {
            return false
        } else if (this.props.editFormId && idbasedEqual) {
            return false
        } else if (!this.props.assetsDetail?.length || !this.props.editFormId && this.props.assetsDetail?.length > 0) {
            return false
        } else {
            return true
        }
    }

    getMinUtilizationFromDate = () => {
        const { assetsDetail, basicDetails, actionType } = this.props;
        const { data } = this.state;
        // Case 1: No assets → use Date of Manufacture
        if (!assetsDetail?.length) {
            return basicDetails?.date_of_manufacture ? moment(basicDetails.date_of_manufacture) : null;
        }
        // Case 2: Add mode → In Case of Pending,Approved and Rejected Date 
        if (actionType === "add") {
            const allPendingList = assetsDetail?.filter(item => [3]?.includes(item?.util_approval_status?.id));
            const latestPendingList = allPendingList?.filter(item => item?.utilization_period?.data === data?.utilization_period?.data);

            const allApprovedList = assetsDetail?.filter(item => [1, 4]?.includes(item?.util_approval_status?.id));
            const latestApprovedList = allApprovedList?.filter(item => item?.utilization_period?.data === data?.utilization_period?.data);

            const allRejectedList = assetsDetail?.filter(item => [2]?.includes(item?.util_approval_status?.id));
            const latestRejectedList = allRejectedList?.filter(item => item?.utilization_period?.data === data?.utilization_period?.data);
            if (latestApprovedList?.length) {
                const latestApprovedToDate = latestApprovedList?.map(item => item?.utilization_period_to)?.filter(Boolean)?.sort((a, b) => moment(b)?.diff(moment(a)))[0];
                return latestApprovedToDate ? moment(latestApprovedToDate) : null;
            } else if (latestRejectedList?.length && !latestApprovedList?.length && !latestPendingList?.length) {
                const latestApprovedToDate = latestRejectedList?.map(item => item?.utilization_period_from)?.filter(Boolean)?.sort((a, b) => moment(a)?.diff(moment(b)))[0];
                return latestApprovedToDate ? moment(latestApprovedToDate) : null;
            } else if (latestPendingList?.length) {
                const latestPendingToDate = latestPendingList?.map(item => item?.utilization_period_to)?.filter(Boolean)?.sort((a, b) => moment(a)?.diff(moment(b)))[0];
                return latestPendingToDate ? moment(latestPendingToDate) : null;
            } else {
                return moment(data?.utilization_period?.data) || null;
            }
        }
        if (data?.utilization_period?.data) {
            return moment(data.utilization_period.data);
        }
        return null;
    };


    render() {
        const { data, error, attachments, operatingThrust, positionDropDownList, pageLoader, utilDateList, addanotherFormData, operatorList} = this.state
        const approvalData = this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2);
        const prevsThrustValue = this.props.assetsDetail.sort((a, b) => b - a).map(filterId => filterId?.current_operating_thrust)[0]
        const filteredOptions = utilDateList?.filter((option) => option?.value >= approvalData?.sort((a, b) => b - a)?.map(filterId => filterId?.utilization_period)[0]?.value);
        const indexing = this.props.assetsDetail.map((item, index) => item.id).sort((b, a) => b - a)[0] === this.props.item?.id
        const tsnoverLimtMess = "TSN has reached its maximum limit of 99,999.99. Please check the TSN and contact support at support@sparta.aero."
        const csnoverLimtMess = "CSN has reached its maximum limit of 99,999 Please check the CSN and contact support at support@sparta.aero."
        const isLastDay = filteredOptions?.filter(item => item?.value === approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period_to)
        const isNotLastDay = filteredOptions?.filter(item => item?.value !== approvalData.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period_to)
        const isFromDate = approvalData?.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period_from
        const isToDate = approvalData?.sort((a, b) => b - a)?.map(filterId => filterId)[0]?.utilization_period_to
        const monthValidation = isFromDate === isToDate ? isNotLastDay : isLastDay ? [...isLastDay, ...isNotLastDay] : isNotLastDay
        return (
            <Fragment>
                <div id="AmpTaskForm" >
                    <div id="HtTaskForm" class="modal" inert>
                        <DialogTitle>
                            {this.props.formTitle}
                            <CloseIcon
                                onClick={() => { this.props.closeAddForm(); this.listResponseBack() }}
                                className="close-icon"
                            />
                        </DialogTitle>
                        <form
                            onSubmit={this.props.actionType === "add" ? (e) => this.handleSubmit(e) : (e) => this.updateData(e)}
                        >
                            <DialogContent>
                                <Grid spacing={1} container>
                                    <Grid item  md={3} sm={6} xs={12}>
                                        <Autocomplete
                                            options={filteredOptions.length > 0 ? monthValidation : utilDateList}
                                            getOptionLabel={(option) => `${option?.data}`}
                                            id="utilization_period"
                                            value={data?.utilization_period}
                                            disabled={this.props.actionType === "edit"}
                                            getOptionDisabled={(option) => !!data?.utilization_period && option.value === data?.utilization_period.value}
                                            onChange={(e, value) => { this.onFieldChange("utilization_period", value); this.onRestErrorKey("utilization_period") }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Utilization Period"
                                                    margin="normal"
                                                    fullWidth
                                                    required
                                                    placeholder="Select Utilization Period"
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    error={error.utilization_period ? true : false}
                                                    helperText={error.utilization_period ? error.utilization_period : ""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                required
                                                id="utilization_period_from"
                                                label="From"
                                                format={acumenCamo ?  fieldDMYShort : dayMonthDateFormat}
                                                inputVariant="outlined"
                                                fullWidth
                                                disableFuture
                                                onPaste={(event) => event.preventDefault()}
                                                InputLabelProps={{ shrink: true }}
                                                minDate={this.getMinUtilizationFromDate()}
                                                // minDate={!this.props.assetsDetail?.length ? moment(this.props.basicDetails?.date_of_manufacture) :
                                                //     this.props.actionType === "add" ? this.props.assetsDetail.sort((a, b) => b - a).map(datefilter => datefilter?.utilization_period_to)[0] ?
                                                //         moment(this.props.assetsDetail.sort((a, b) => b - a).map(datefilter => datefilter?.utilization_period_to)[0]) : ''
                                                //         : moment(data?.utilization_period?.data)||
                                                //         moment(data?.utilization_period?.data)}
                                                maxDate={data?.utilization_period_to ? moment(data?.utilization_period_to) : moment(data?.utilization_period?.value)}
                                                value={data?.utilization_period_from || null}
                                                error={data?.utilization_period_from ? false : error.utilization_period_from ? true : false}
                                                helperText={data?.utilization_period_from ? "" : error.utilization_period_from ? error.utilization_period_from : ""}
                                                onFocus={() => this.onRestErrorKey("utilization_period_from")}
                                                onChange={(data, value) => {
                                                    this.onFieldChange("utilization_period_from", moment(data).isValid() ? moment(data).format(backendDateFormat) : null)
                                                    this.onRestErrorKey("utilization_period_from")
                                                }}
                                                disabled={!data?.utilization_period?.value}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                required
                                                id="utilization_period_to"
                                                label="To"
                                                format={acumenCamo ?  fieldDMYShort : dayMonthDateFormat}
                                                inputVariant="outlined"
                                                fullWidth
                                                disableFuture
                                                onPaste={(event) => event.preventDefault()}
                                                InputLabelProps={{ shrink: true }}
                                                minDate={moment(data?.utilization_period_from)}
                                                maxDate={moment(data?.utilization_period?.value)}
                                                value={data?.utilization_period_to || null}
                                                error={data?.utilization_period_to ? false : error.utilization_period_to ? true : false}
                                                helperText={data?.utilization_period_to ? "" : error.utilization_period_to ? error.utilization_period_to : ""}
                                                onFocus={() => this.onRestErrorKey("utilization_period_to")}
                                                onChange={(data, value) => {
                                                    this.onFieldChange("utilization_period_to", moment(data).isValid() ? moment(data).format(backendDateFormat) : null)
                                                    this.onRestErrorKey("utilization_period_to")
                                                }}
                                                disabled={!data?.utilization_period?.value}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <Autocomplete
                                            options={operatingThrust ? operatingThrust : []}
                                            getOptionLabel={(option) => option?.name}
                                            id="current_operating_thrust"
                                            value={data?.current_operating_thrust ? data?.current_operating_thrust : acumenCamo ? null : prevsThrustValue}
                                            onChange={(e, value) => { this.onFieldChange("current_operating_thrust", value); this.onRestErrorKey("current_operating_thrust") }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Op.Thrust (Current)"
                                                    margin="normal"
                                                    fullWidth
                                                    required={acumenCamo ? false:true}
                                                    error={acumenCamo ? false:error.current_operating_thrust ? true : false}
                                                    helperText={acumenCamo ? "": error.current_operating_thrust ? error.current_operating_thrust : ""}
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Select Op.Thrust (Current)"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <TextField
                                            required
                                            variant="outlined"
                                            label="Monthly FH"
                                            name="monthly_FH"
                                            id="monthly_FH"
                                            value={data?.monthly_FH ? data?.monthly_FH : ''}
                                            error={error.monthly_FH ? true : false}
                                            InputLabelProps={{ shrink: true }}
                                            helperText={error.monthly_FH ? error.monthly_FH : ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const numericValue = value.replace(/[^\d.]/g, '');
                                                const dotCount = (numericValue.match(/\./g) || []).length;
                                                const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 4 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 3 && regexConstants.numberWithDot.test(numericValue);
                                                if (isValid || value === "") {
                                                    this.onFieldChange("monthly_FH", numericValue);
                                                }
                                                this.onRestErrorKey("monthly_FH");
                                            }}
                                            onPaste={(e) => e.preventDefault()}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <TextField
                                            required
                                            variant="outlined"
                                            label="Monthly FC"
                                            name="monthly_FC"
                                            id="monthly_FC"
                                            InputLabelProps={{ shrink: true }}
                                            value={data?.monthly_FC !== undefined && data?.monthly_FC !== null ? data.monthly_FC : ''}
                                            error={error.monthly_FC ? true : false}
                                            inputProps={{ maxLength: 3 }}
                                            helperText={error.monthly_FC ? error.monthly_FC : ""}
                                            onChange={(e) => { (e.target.value || e.target.value === '') && (regexConstants.onlyNumeric.test(e.target.value) || e.target.value === "") && this.onFieldChange('monthly_FC', e.target.value); this.onRestErrorKey("monthly_FC") }}
                                            onPaste={(e) => e.preventDefault()}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <TextField
                                            variant="outlined"
                                            label="TSN"
                                            id="tsn"
                                            helperText={!indexing && this.props.assetsDetail?.length >= 1 && data.monthly_FH ? (parseFloat(data.monthly_FH) + parseFloat(this.props.assetsDetail.sort((a, b) => b - a).filter(item => item)[0]?.tsn)) > 99999.99 ? <span style={{ color: 'red' }}>{tsnoverLimtMess}</span> : '' : ''}
                                            InputLabelProps={{ shrink: true }}
                                            disabled={this.props.actionType === "edit" ? indexing ? false : this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length > 1 : this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length > 0}
                                            value={
                                                this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length === 1 && this.props.actionType === "edit" ?
                                                    format_Commas(data.tsn) : indexing ? format_Commas(data.tsn) : this.props.assetsDetail?.length > 1 && this.props.actionType === "edit" ? format_Commas(this.tsnCalc()) :
                                                        this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length > 0 && this.props.actionType === "add" ?
                                                            format_Commas(this.tsnCalc()) : format_Commas(data.tsn)}
                                            onChange={(e) => {
                                                const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                                const numericValue = value.replace(/[^\d.]/g, '');
                                                const dotCount = (numericValue.match(/\./g) || []).length;
                                                const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                                if (isValid || value === "") {
                                                    this.onFieldChange("tsn", numericValue);
                                                    const approvedCount = this.props.assetsDetail?.filter(item => item?.util_approval_status?.id !== 2)?.length || 0;
                                                    const isFirstUtilEntry = this.props.actionType === "edit" ? approvedCount === 1 : approvedCount === 0;
                                                    if (isFirstUtilEntry) {
                                                        this.onFieldChange("removal_tslsv", this.getRemovalTslsvFrom(numericValue));
                                                    }
                                                }
                                                this.onRestErrorKey("tsn");
                                            }}

                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <TextField
                                            variant="outlined"
                                            label="CSN"
                                            id="csn"
                                            InputLabelProps={{ shrink: true }}
                                            helperText={!indexing && this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length >= 1 && data?.monthly_FC ? (parseInt(data.monthly_FC) + parseInt(this.props.assetsDetail.sort((a, b) => b - a).filter(item => item)[0]?.csn)) > 99999 ? <span style={{ color: 'red' }}>{csnoverLimtMess}</span> : '' : ''}
                                            disabled={this.props.actionType === "edit" ? indexing ? false : this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length > 1 : this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length > 0}
                                            value={
                                                this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length === 1 && this.props.actionType === "edit" ?
                                                    format_Commas(data.csn) : indexing ? format_Commas(data.csn) : this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length > 1 && this.props.actionType === "edit" ? format_Commas(this.csnCalc()) :
                                                        this.props.assetsDetail.filter(item => item?.util_approval_status?.id !== 2)?.length > 0 && this.props.actionType === "add" ?
                                                            format_Commas(this.csnCalc()) : format_Commas(data.csn)}
                                            onPaste={(e) => e.preventDefault()}
                                            onChange={(e) => {
                                                const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                                const isValid = value?.length <= 5 && regexConstants.onlyNumeric.test(value);
                                                if (isValid || value === "") {
                                                    this.onFieldChange("csn", value);
                                                    const approvedCount = this.props.assetsDetail?.filter(item => item?.util_approval_status?.id !== 2)?.length || 0;
                                                    const isFirstUtilEntry = this.props.actionType === "edit" ? approvedCount === 1 : approvedCount === 0;
                                                    if (isFirstUtilEntry) {
                                                        this.onFieldChange("removal_cslsv", this.getRemovalCslsvFrom(value));
                                                    }
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <TextField
                                            variant="outlined"
                                            label="Monthly Derate"
                                            id="monthly_derate"
                                            InputLabelProps={{ shrink: true }}
                                            value={data.monthly_derate !== null && data.monthly_derate !== undefined ? data.monthly_derate : ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const numericValue = value.replace(/[^\d.]/g, '');
                                                const dotCount = (numericValue.match(/\./g) || []).length;
                                                const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 3 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 2 && regexConstants.numberWithDot.test(numericValue);
                                                if (isValid || value === "") {
                                                    this.onFieldChange("monthly_derate", numericValue);
                                                }
                                                this.onRestErrorKey("monthly_derate");
                                            }}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <TextField
                                            variant="outlined"
                                            label="Location Reg Aircraft"
                                            id="location_reg_aircraft"
                                            InputLabelProps={{ shrink: true }}
                                            value={data?.location_reg_aircraft}
                                            inputProps={{ maxLength: 50 }}
                                            onChange={(e) => { this.onFieldChange('location_reg_aircraft', e.target.value); this.onRestErrorKey("location_reg_aircraft") }}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <Autocomplete
                                            options={positionDropDownList.filter((item) => [0, 1, 2].includes(item.id)) || []}
                                            getOptionLabel={(option) => option?.label}
                                            id="location_position"
                                            value={data?.location_position}
                                            onChange={(e, value) => this.onFieldChange("location_position", value)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Location Position"
                                                    margin="normal"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Select Location Postion"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <TextField
                                            variant="outlined"
                                            label="Engine Stand Location"
                                            fullWidth
                                            margin="normal"
                                            id="engine_stand_location"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ maxLength: 50 }}
                                            value={data.engine_stand_location ? data.engine_stand_location : ''}
                                            onChange={(e) => { this.onFieldChange('engine_stand_location', e.target.value); this.onRestErrorKey("engine_stand_location") }}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <TextField
                                            variant="outlined"
                                            label="Location Country"
                                            id="location_country"
                                            InputLabelProps={{ shrink: true }}
                                            value={data.location_country || ''}
                                            inputProps={{ maxLength: 50 }}
                                            onChange={(e) => { this.onFieldChange('location_country', e.target.value); this.onRestErrorKey("location_country") }}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <Autocomplete
                                            options={['Benign', 'Middle East/North Africa', 'India', 'China']}
                                            getOptionLabel={(option) => option}
                                            id="operating_environment"
                                            value={data?.operating_environment ? data?.operating_environment : null}
                                            onChange={(e, value) => this.onFieldChange("operating_environment", value)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Operating Enviroment"
                                                    margin="normal"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Select Operating Enviroment"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item md={6} sm={6} xs={12}>
                                        <TextField
                                            variant="outlined"
                                            label="Removal Reason"
                                            id="reason_of_removal"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ maxLength: 100 }}
                                            value={data.reason_of_removal ? data.reason_of_removal : ''}
                                            onChange={(e) => { this.onFieldChange('reason_of_removal', e.target.value); this.onRestErrorKey("reason_of_removal") }}
                                        />
                                    </Grid>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                id="date_of_installation"
                                                label={
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        Date Of Installation
                                                        <Tooltip
                                                            title={this.props?.editFormId ? "Editing the date of installation field will affect all subsequent entries" : 'Date of Instalation must be same as Utilization Period From Date'}
                                                            placement="top"
                                                            arrow
                                                            enterTouchDelay={0}
                                                        >
                                                            <span>
                                                                <InfoIcon fontSize='small'  style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                }
                                                format={acumenCamo ?  moment(data?.utilization_period_from).format(fieldDMYShort) : dayMonthDateFormat}
                                                inputVariant="outlined"
                                                fullWidth
                                                disableFuture
                                                // disabled={this.doI_Freeze()}
                                                onPaste={(event) => event.preventDefault()}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { pointerEvents: 'auto' }
                                                }}
                                                minDate={moment(data?.utilization_period?.data)}
                                                maxDate={data?.date_of_removal ? moment(data?.date_of_removal) : moment(data?.utilization_period?.value)}
                                                value={data?.date_of_installation || null}
                                                error={error.date_of_installation ? true : false}
                                                helperText={error.date_of_installation ? error.date_of_installation : ""}
                                                onFocus={() => this.onRestErrorKey("date_of_installation")}
                                                onChange={(data, value) => {
                                                    this.onFieldChange("date_of_installation", moment(data).isValid() ? moment(data).format(backendDateFormat) : null)
                                                    this.onRestErrorKey("date_of_installation")
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    {
                                        data?.date_of_installation ?
                                            <>
                                                <Grid item md={3} sm={6} xs={12}>
                                                    <Autocomplete
                                                        options={operatorList || []}
                                                        getOptionLabel={(option) => option?.name}
                                                        id="fitment_operator"
                                                        value={data?.fitment_operator || null}
                                                        onChange={(e, value) => this.onFieldChange("fitment_operator", value)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Fitment Operator"
                                                                margin="normal"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                placeholder="Select Fitment Operator"
                                                                variant="outlined"

                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="Fitment A/C Type"
                                                        id="fitment_aircraft"
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ maxLength: 10 }}
                                                        value={data.fitment_aircraft ? data.fitment_aircraft : ''}
                                                        onChange={(e) => this.onFieldChange('fitment_aircraft', e.target.value)}
                                                    />
                                                </Grid>
                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        label={
                                                            <span style={{ verticalAlign: 'super' }}>
                                                                Fitment A/F Hours
                                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
                                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                                </Tooltip>
                                                            </span>
                                                        }
                                                        id="fitment_aircraft_flying_hours"
                                                        error={error.fitment_aircraft_flying_hours ? true : false}
                                                        helperText={error.fitment_aircraft_flying_hours ? error.fitment_aircraft_flying_hours : ""}
                                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.fitment_aircraft_flying_hours) && 10 }}
                                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                                        value={regexConstants.alphanumespcespclchar.test(data.fitment_aircraft_flying_hours) ? data.fitment_aircraft_flying_hours : format_Commas(data?.fitment_aircraft_flying_hours.replace(/[^0-9.]/g, ''))}
                                                        onChange={(e) => {
                                                            const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                                            const numericValue = value.replace(/[^\d.]/g, '');
                                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                                            const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 6 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                                this.onFieldChange("fitment_aircraft_flying_hours", e.target.value);
                                                                this.setState({ error: { ...error, fitment_aircraft_flying_hours: e.target.value === (null || undefined || "") ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('Fitment Aircraft Flying Hours', true) }, })
                                                            } else if (isValid || value === "") {
                                                                this.onFieldChange("fitment_aircraft_flying_hours", numericValue);
                                                                this.setState({ error: { ...error, fitment_aircraft_flying_hours: regexConstants.numberWithDot.test(numericValue) || e.target.value === (null || undefined || "") ? "" : e.target.value === null ? "" : "" } })
                                                            }
                                                        }}

                                                    />
                                                </Grid>
                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        label={
                                                            <span style={{ verticalAlign: 'super' }}>
                                                                Fitment A/F Cycle
                                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999 </span>} arrow>
                                                                    <InfoIcon fontSize='small'  style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                                </Tooltip>
                                                            </span>
                                                        }
                                                        name="fitment_aircraft_flying_cycle"
                                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.fitment_aircraft_flying_cycle) && 9 }}
                                                        error={error.fitment_aircraft_flying_cycle ? true : false}
                                                        helperText={error.fitment_aircraft_flying_cycle ? error.fitment_aircraft_flying_cycle : ""}
                                                        value={regexConstants.alphanumespcespclchar.test(data.fitment_aircraft_flying_cycle) ? data.fitment_aircraft_flying_cycle : format_Commas(data?.fitment_aircraft_flying_cycle.toString().replace(/[^0-9.]/g, ''))}
                                                        onChange={(e) => {
                                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                                this.onFieldChange("fitment_aircraft_flying_cycle", e.target.value);
                                                                this.setState({ error: { ...error, fitment_aircraft_flying_cycle: e.target?.value === null || e.target?.value === "" ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('Fitment AIrcraft Flying Cycle', false) } })

                                                            } else {
                                                                this.setState({ error: { ...error, fitment_aircraft_flying_cycle: e.target?.value === null || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === "" ? "" : "" } })
                                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('fitment_aircraft_flying_cycle', e.target.value, 'removeComma')
                                                            }

                                                        }
                                                        }
                                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                                    />
                                                </Grid>
                                            </> : null
                                    }
                                </Grid>
                                <Grid spacing={1} container>
                                    <Grid item md={3} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                id="date_of_removal"
                                                label={
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        Date of Removal
                                                        <Tooltip
                                                            title={this.props.editFormId ? "Editing the date of removal field will affect all subsequent entries" : 'Date of Removal must be same as Utilization Period To Date'}
                                                            placement="top"
                                                            arrow
                                                            enterTouchDelay={0}
                                                        >
                                                            <span>
                                                                <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                }
                                                format={acumenCamo ?  moment(data?.utilization_period_from).format(fieldDMYShort) : dayMonthDateFormat}
                                                inputVariant="outlined"
                                                fullWidth
                                                disableFuture
                                                // disabled={this.dor_Freeze()}
                                                onPaste={(event) => event.preventDefault()}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { pointerEvents: 'auto' }
                                                }}
                                                minDate={moment(data?.utilization_period?.data)}
                                                maxDate={moment(data?.utilization_period?.value)}
                                                value={data?.date_of_removal || null}
                                                error={error.date_of_removal ? true : false}
                                                helperText={error.date_of_removal ? error.date_of_removal : ""}
                                                onFocus={() => this.onRestErrorKey("date_of_removal")}
                                                onChange={(data, value) => {
                                                    this.onFieldChange("date_of_removal", moment(data).isValid() ? moment(data).format(backendDateFormat) : null);
                                                    this.onRestErrorKey("date_of_removal");
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>

                                    {
                                        data?.date_of_removal ?
                                            <>



                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        label={
                                                            <span style={{ verticalAlign: 'super' }}>
                                                                Removal A/F Hours
                                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
                                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                                </Tooltip>
                                                            </span>
                                                        }
                                                        id="removal_aircraft_flying_hours"
                                                        error={error.removal_aircraft_flying_hours ? true : false}
                                                        helperText={error.removal_aircraft_flying_hours ? error.removal_aircraft_flying_hours : ""}
                                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.removal_aircraft_flying_hours) && 10 }}
                                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                                        value={regexConstants.alphanumespcespclchar.test(data.removal_aircraft_flying_hours) ? data.removal_aircraft_flying_hours : format_Commas(data?.removal_aircraft_flying_hours.replace(/[^0-9.]/g, ''))}
                                                        onChange={(e) => {
                                                            const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                                            const numericValue = value.replace(/[^\d.]/g, '');
                                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                                            const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 6 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                                this.onFieldChange("removal_aircraft_flying_hours", e.target.value);
                                                                this.setState({ error: { ...error, removal_aircraft_flying_hours: e.target.value === (null || undefined || "") ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('Removal Aircraft Flying Hours', true) } })
                                                            } else if (isValid || value === "") {
                                                                this.onFieldChange("removal_aircraft_flying_hours", numericValue);
                                                                this.setState({ error: { ...error, removal_aircraft_flying_hours: regexConstants.numberWithDot.test(numericValue) || e.target.value === (null || undefined || "") ? "" : e.target.value === null ? "" : "" } })
                                                            }
                                                        }}

                                                    />
                                                </Grid>
                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        id="removal_aircraft_flying_cycle"
                                                        label={
                                                            <span style={{ verticalAlign: 'super' }}>
                                                                Removal A/F Cycle
                                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999 </span>} arrow>
                                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                                </Tooltip>
                                                            </span>
                                                        }
                                                        name="removal_aircraft_flying_cycle"
                                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.removal_aircraft_flying_cycle) && 9 }}
                                                        error={error.removal_aircraft_flying_cycle ? true : false}
                                                        helperText={error.removal_aircraft_flying_cycle ? error.removal_aircraft_flying_cycle : ""}
                                                        value={regexConstants.alphanumespcespclchar.test(data.removal_aircraft_flying_cycle) ? data.removal_aircraft_flying_cycle : format_Commas(data?.removal_aircraft_flying_cycle.toString().replace(/[^0-9.]/g, ''))}
                                                        onChange={(e) => {
                                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                                this.onFieldChange("removal_aircraft_flying_cycle", e.target.value);
                                                                this.setState({ error: { ...error, removal_aircraft_flying_cycle: e.target?.value === null || e.target?.value === "" ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('Removal AIrcraft Flying Cycle', false) } })

                                                            } else {
                                                                this.setState({ error: { ...error, removal_aircraft_flying_cycle: e.target?.value === null || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === "" ? "" : "" } })
                                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('removal_aircraft_flying_cycle', e.target.value, 'removeComma')
                                                            }
                                                        }
                                                        }
                                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                                    />
                                                </Grid>
                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        label={
                                                            <span style={{ verticalAlign: 'super' }}>
                                                                {smbcInstance ? 'Removal TSPR ' : 'Removal TSLSV'}
                                                                <Tooltip placement='right' title={
                                                                    <span> SV Toggle ON : Data is automatically fetched and cannot be edited.
                                                                        <br/>
                                                                        SV Toggle OFF : Data is automatically fetched and cannot be edited</span>}
                                                                    arrow>
                                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                                </Tooltip>
                                                            </span>
                                                        }
                                                        // error={error.removal_tslsv ? true : false}
                                                        // helperText={error.removal_tslsv ? error.removal_tslsv : ""}
                                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.removal_tslsv) && 9 }}
                                                        // Add flow (and edit flow once FH/FC/TSN/CSN are changed, or a Date of Removal is newly
                                                        // selected on an entry saved without one): derive Removal TSLSV live from the current TSN and
                                                        // SV reset data. Edit flow with untouched inputs: keep the originally saved value.
                                                        value={this.shouldDeriveRemoval()
                                                            ? this.formatRemovalTwoDecimals(this.getRemovalTslsv())
                                                            : regexConstants.alphanumespcespclchar.test(data.removal_tslsv) ? data.removal_tslsv : this.formatRemovalTwoDecimals(data?.removal_tslsv)}
                                                        id="removal_tslsv"
                                                        // value={format_Commas(data?.removal_tslsv)}
                                                        disabled
                                                        onChange={(e) => {
                                                            const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                                            const numericValue = value.replace(/[^\d.]/g, '');
                                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                                            const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 6 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                                this.onFieldChange("removal_tslsv", e.target.value);
                                                                this.setState({ error: { ...error, removal_tslsv: e.target?.value === null || e.target?.value === "" ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess(smbcInstance ? 'Removal TSPR ' : 'Removal TSLSV', true) }, })

                                                            } else if (isValid || value === "") {
                                                                this.onFieldChange("removal_tslsv", numericValue);
                                                                this.setState({ error: { ...error, removal_tslsv: regexConstants.numberWithDot.test(numericValue) || e.target.value === (null || undefined || "") ? "" : e.target.value === null ? "" : "" } })

                                                            }
                                                        }}
                                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                                    />
                                                </Grid>

                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        label={
                                                            <span style={{ verticalAlign: 'super' }}>
                                                                {smbcInstance ? 'Removal CSPR ' : 'Removal CSLSV'}
                                                                <Tooltip placement='right' title={
                                                                    <span> SV Toggle ON : Data is automatically fetched and cannot be edited.
                                                                        <br />
                                                                        SV Toggle OFF : Data is automatically fetched and cannot be edited</span>}
                                                                    arrow>
                                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                                </Tooltip>
                                                            </span>
                                                        }
                                                        id="removal_cslsv"
                                                        // value={format_Commas(data?.removal_cslsv)}
                                                        disabled
                                                        // error={error.removal_cslsv ? true : false}
                                                        // helperText={error.removal_cslsv ? error.removal_cslsv : ""}
                                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.removal_cslsv) && 9 }}
                                                        value={this.shouldDeriveRemoval()
                                                            ? format_Commas(String(this.getRemovalCslsv() ?? '').replace(/[^0-9.]/g, ''))
                                                            : regexConstants.alphanumespcespclchar.test(data.removal_cslsv) ? data.removal_cslsv : format_Commas(String(data?.removal_cslsv ?? '').replace(/[^0-9.]/g, ''))}
                                                        onChange={(e) => {
                                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                                this.onFieldChange("removal_cslsv", e.target.value);
                                                                this.setState({ error: { ...error, removal_cslsv: e.target?.value === null || e.target?.value === "" ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess(smbcInstance ? 'Removal CSPR ' : 'Removal CSLSV', false) }, })
                                                            } else {
                                                                this.setState({ error: { ...error, removal_cslsv: e.target?.value === null || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === "" ? "" : "" } })
                                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('removal_cslsv', e.target.value, 'removeComma')
                                                            }
                                                        }
                                                        }
                                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                                    />
                                                </Grid>
                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="EGTM"
                                                        id="removal_egtm"
                                                        value={data.removal_egtm}
                                                        onChange={(e, value) => this.onFieldChange("removal_egtm", e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ maxLength: 250 }}
                                                    />
                                                </Grid>
                                                <Grid item md={3} sm={6} xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="Removal Event"
                                                        id="removal_event"
                                                        value={data.removal_event}
                                                        onChange={(e, value) => this.onFieldChange("removal_event", e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ maxLength: 250 }}
                                                    />
                                                </Grid>
                                            </>
                                            : null
                                    }
                                </Grid>
                                <div className="border-grey"></div>
                                <Grid spacing={1} container>
                                    <Grid item md={6} sm={6} xs={12}>
                                        <TextField
                                            required={this.props?.editFormId}
                                            error={error.remarks ? true : false}
                                            helperText={error.remarks ? error.remarks : ""}
                                            label={
                                                <span style={{ verticalAlign: 'super' }}>
                                                    Remarks
                                                    {data?.id && <Tooltip placement='right' title={<span>Remarks is mandatory </span>} arrow>
                                                        <InfoIcon fontSize='small'  style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                    </Tooltip>}
                                                </span>
                                            }
                                            margin='normal'
                                            variant='outlined'
                                            fullWidth
                                            value={data?.remarks || ''}
                                            InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                            onChange={(e) => { this.onFieldChange('remarks', e.target.value); this.onRestErrorKey("remarks") }}
                                            rows={3}
                                            multiline
                                            inputProps={{ maxLength: 250 }}
                                        />
                                    </Grid>
                                    <Grid item md={6} sm={6} xs={12}>
                                        <div className="upload-amp-textbox" style={{ border: "1px solid gray", textAlign: 'center' }}>
                                            <ul className="list-inline spacing-list">
                                                <li className="list-inline-item" onClick={this.handleOpenUploadFile}>
                                                    <span className="flex-centered"><AttachmentIcon color='primary' fontSize='small' /> Upload File</span>
                                                </li>
                                                <li className="list-inline-item" onClick={this.handleOpenFile}>
                                                    <span className="flex-centered"><LinkIcon color='primary' fontSize='small' />Link file from Records Module</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid id="data-container" spacing={1} container>
                                    <Grid spacing={1} container>
                                        {this.props.actionType === 'add' ?
                                            <div className='checklist-files'>
                                                <ul className='list-inline'>
                                                    {data?.checklist?.map((file) =>
                                                        <li className='list-inline-item'>
                                                            <span className='file-name'>{file.name}</span>
                                                            <span className='file-remove'>
                                                                <a href={decodeURIComponent(file.path)} download={file.name}>  <GetAppIcon color="primary" /></a>
                                                                <CloseIcon onClick={() => this.onRemoveFile(file)} color='secondary' fontSize='small' />
                                                            </span>
                                                        </li>
                                                    )}
                                                    {attachments?.map((attachments) =>
                                                        <li className='list-inline-item'>
                                                            <span className='file-name'>{attachments.file_name}</span>
                                                            <span className='file-remove'>
                                                                <a href={decodeURIComponent(attachments.file)} download={attachments.file_name}>  <GetAppIcon color="primary" /></a>
                                                                <CloseIcon onClick={() => this.onRemoveCamoFile(attachments)} color='secondary' fontSize='small' />
                                                            </span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                            :
                                            <div className='checklist-files'>
                                                <ul className='list-inline'>
                                                    {data?.checklist?.files?.map((file) =>
                                                        <li className='list-inline-item'>
                                                            <span className='file-name'>{file.name}</span>
                                                            <span className='file-remove'>
                                                                <a href={decodeURIComponent(file.path)} download={file.name}>  <GetAppIcon color="primary" /></a>
                                                                <CloseIcon onClick={() => this.onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
                                                            </span>
                                                        </li>
                                                    )}
                                                    {(data.checklist?.folders?.length > 0) &&
                                                        data.checklist?.folders.map((file) => {
                                                            return (
                                                                <li className='list-inline-item' key={file.id}>
                                                                    <Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
                                                                        <a href={`${config.domain.records}${assetType[this.props.props?.match.params.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new"><img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Reacords Data Room" /></a>
                                                                    </Tooltip>
                                                                    <span className='file-name'>{file.name}</span>
                                                                    <span className='file-remove'>
                                                                        <CloseIcon onClick={() => this.onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
                                                                    </span>
                                                                </li>
                                                            );
                                                        })}
                                                    {attachments?.map((attachments) =>
                                                        <li className='list-inline-item'>
                                                            <span className='file-name'>{attachments.file_name}</span>
                                                            <span className='file-remove'>
                                                                <a href={decodeURIComponent(attachments.file)} download={attachments.file_name}>  <GetAppIcon color="primary" /></a>
                                                                <CloseIcon onClick={() => this.deleteAttachmentFile(attachments.id, attachments)} color='secondary' fontSize='small' />
                                                            </span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>}
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className="actions-btn">
                                <Button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.props.actionType === "add" ? (e) => this.addFormData(e) : (e) => this.updateData(e)}
                                >
                                    {this.props.actionType === "add" ? "Add" : "Update"}
                                </Button>

                                {this.props.actionType === "add" ? (
                                    <Button onClick={(e) => this.saveAndAddAnother(e)} type="button" className="btn btn-primary" > Save & Add Another </Button>
                                ) : (
                                    ""
                                )}
                                <Button type="button" className="btn btn-primary" onClick={() => { this.props.closeAddForm(); this.listResponseBack() }}  > Close </Button>
                            </DialogActions>
                            <Dialog
                                open={this.state.open}
                                onClose={this.handleCloseAttachment}
                                id="htDialog"
                            >
                            </Dialog>
                            <Dialog open={this.state.linkFile} onClose={this.handleCloseFile} id="htDialog">
                                <LinkFiles
                                    handleClose={() => this.handleCloseFile()}
                                    uuid={this.props?.uuid?.uuid}
                                    editFormId={this.props.editFormId}
                                    getResponseBack={(file) => this.getResponseBack(file)}
                                    listResponseBack={(file) => this.listResponseBack(file)}
                                    actionType={this.props.actionType}
                                    onLinkFile={(file, any, type) => this.onLinkFile(file, any, type)}
                                    modType="util"
                                    last_used_folder_uuid={this.props.last_used_folder_uuid_link_document}
                                    uploadFileInfo={data}
                                    attachments={attachments}
                                    type="link"
                                />
                            </Dialog>
                            <Dialog open={this.state.uploadFile} onClose={this.handleUploadFileCloseFile} id="htDialog">
                                <UploadFile
                                    handleClose={() => this.handleUploadFileCloseFile()}
                                    uuid={this.props?.uuid?.uuid}
                                    editFormId={this.props.editFormId}
                                    getResponseBack={(file) => this.getResponseBack(file)}
                                    listResponseBack={(file) => this.listResponseBack(file)}
                                    actionType={this.props.actionType}
                                    onLinkFile={(file, uuid) => this.onLinkFile(file, uuid)}
                                    modType="util"
                                    uploadFileInfo={data}
                                    last_used_folder_uuid={this.props.last_used_folder_uuid}
                                    onUpload={(file) => this.onUpload(file)}
                                    type="upload"
                                    checkbox_last_used_folder_uuid={this.props.checkbox_last_used_folder_uuid}
                                    checkbox_last_used_folder_name={this.props.checkbox_last_used_folder_name}
                                />
                            </Dialog>
                        </form>
                    </div>
                    {pageLoader ? <PageLoader /> : null}
                </div>
            </Fragment>
        )
    }
}
export default UtilizationFormData